<script>
    import { createEventDispatcher } from "svelte";
    import { _log } from "./utils/logger";
    import l from "./utils/locale";

    const dispatch = createEventDispatcher();
    export let name;

    export let isChecked = false;
    let isActive = true;
    $: _log("isChecked", isChecked);
    function switchBtn() {
        _log("switchBtn()");
        isActive = !isActive;
        dispatch("switch", { data: isActive });
    }
</script>

<div class="icon">
    {#if name === "link"}
        <svg
            xmlns="http://www.w3.org/2000/svg"
            class="ionicon"
            viewBox="0 0 512 512"
            class:activeIcon={isChecked}
            ><title>{l["link"]}</title><path
                d="M208 352h-64a96 96 0 010-192h64M304 160h64a96 96 0 010 192h-64M163.29 256h187.42"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="6"
            /></svg
        >
    {:else if name === "filter"}
        <svg
            xmlns="http://www.w3.org/2000/svg"
            class="ionicon"
            viewBox="0 0 512 512"
            class:activeIcon={isChecked}
            ><title>{l["filter"]}</title>
            <path
                d="M472 168H40a24 24 0 010-48h432a24 24 0 010 48zM392 280H120a24 24 0 010-48h272a24 24 0 010 48zM296 392h-80a24 24 0 010-48h80a24 24 0 010 48z"
            /></svg
        >
    {:else if name === "draw"}
        <svg
            xmlns="http://www.w3.org/2000/svg"
            class="ionicon"
            viewBox="0 0 512 512"
            class:activeIcon={isChecked}
            ><title>{l["draw"]}</title><path
                d="M233.15 360.11a15.7 15.7 0 01-4.92-.77 16 16 0 01-10.92-13c-2.15-15-19.95-32.46-36.62-35.85a16 16 0 01-8.69-26.33l211.09-235.1c.19-.22.39-.43.59-.63a56.57 56.57 0 0179.89 0 56.51 56.51 0 01.11 79.78l-219 227a16 16 0 01-11.53 4.9zM119.89 480.11c-32.14 0-65.45-16.89-84.85-43a16 16 0 0112.85-25.54c5.34 0 20-4.87 20-20.57 0-39.07 31.4-70.86 70-70.86s70 31.79 70 70.86c0 49.12-39.48 89.11-88 89.11z"
            /></svg
        >
    {:else if name === "resize"}
        <svg
            xmlns="http://www.w3.org/2000/svg"
            class="ionicon"
            viewBox="0 0 512 512"
            class:activeIcon={isChecked}
            ><title>{l["resize"]}</title><path
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="32"
                d="M304 96h112v112M405.77 106.2L111.98 400.02M208 416H96V304"
            /></svg
        >
        <!-- {:else if name === "autocrop"}
        <svg
            xmlns="http://www.w3.org/2000/svg"
            class="ionicon"
            viewBox="0 0 512 512"
            class:activeIcon={isChecked}
            ><title>autoctop</title><path
                d="M458 346H192a26 26 0 01-26-26V54a22 22 0 00-44 0v68H54a22 22 0 000 44h68v154a70.08 70.08 0 0070 70h154v68a22 22 0 0044 0v-68h68a22 22 0 000-44z"
            /><path
                d="M214 166h106a26 26 0 0126 26v106a22 22 0 0044 0V192a70.08 70.08 0 00-70-70H214a22 22 0 000 44z"
            /></svg
        > -->
    {:else if name === "find"}
        <svg
            xmlns="http://www.w3.org/2000/svg"
            class="ionicon"
            viewBox="0 0 512 512"
            class:activeIcon={isChecked}
            ><title>{l["find"]}</title><path
                d="M456.69 421.39L362.6 327.3a173.81 173.81 0 0034.84-104.58C397.44 126.38 319.06 48 222.72 48S48 126.38 48 222.72s78.38 174.72 174.72 174.72A173.81 173.81 0 00327.3 362.6l94.09 94.09a25 25 0 0035.3-35.3zM97.92 222.72a124.8 124.8 0 11124.8 124.8 124.95 124.95 0 01-124.8-124.8z"
            /></svg
        >
    {/if}
</div>

<style>
</style>
